<template>
  <div v-if="user.id">
    <ImageWall 
      :isEdit="true" @cropped="onCropped" :url="cover"
      ref="imageWall"
    />
    <v-container>
      <!-- Image Wall -->
      <div class="widthPage">
        <!-- Avatar -->
        <Avatar class="pull-top pb-md-5" isMine :note="user.shortBio" />
        <!-- Card Relation -->
        <RelationCard :data="user" />

        <div class="d-flex justify-end">
          <RowIconSocial :data="user" />
        </div>
        <!-- Tabs -->
        <ProfileUser />
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ImageWall from "@/components/ImageWall";
import Avatar from "@/components/Avatar/Avatar";
import RelationCard from "@/components/Card/RelationCard";
import RowIconSocial from "@/components/RowIconSocial";
import ProfileUser from "@/components/ProfileUser/Tabs.vue";

export default {
  name: "Profile",
  components: {
    ImageWall,
    Avatar,
    RelationCard,
    RowIconSocial,
    ProfileUser,
  },
  data() {
    return {
      cover: this.imgUrl("no-img-user.jpg"),
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      step: (state) => state.stepper.step,
    }),
  },
  methods: {
    async onCropped(file) {
      //uploader
      let result = await this.$store.dispatch("coverUpdate", file);
      this.$refs.imageWall.$refs.CoverUploader.dialog = false
      if (result.error) {
        this.$toast.alert(result.error.message);
      } else {
        this.cover = file;
        this.$toast.success(this.$gettext(`Update success`));
      }
    },
  },
  async created() {
    await this.$store.dispatch("getMe");
    this.cover = this.user.cover
  },
};
</script>

<style lang="scss">
.widthPage {
  max-width: 1130px;
  margin: 0 auto;
  display: block;
  position: relative;
}
.theme--light {
  .v-tabs-items {
    background-color: transparent !important;
    margin-top: 25px;
  }
  .theme--light.v-tabs > .v-tabs-bar {
    background-color: transparent;
  }
}
</style>
